import './index.css';
import { createContext } from 'react';

const noopFunc = (() => void 0);
const SnackbarContext = createContext({
    animateIn: noopFunc,
    animateOut: noopFunc,
    isShown: () => false,
    setContainerRef: noopFunc,
});

export { SnackbarContext };
//# sourceMappingURL=context.js.map
